import React from 'react'
import gql from 'graphql-tag'
import { useLazyQuery } from '@apollo/react-hooks'

import Layout from 'components/PrivateRoutes/Layout'
import DatePicker from 'components/shared/DatePicker'

import Invoices from './Invoices'

import './index.css'

export const ServiceProviderQuery = gql`
  query ServiceProviderQuery($from: Date, $to: Date) {
    serviceProvider {
      id
      invoiceLines(from: $from, to: $to) {
        id
        state
        description
        quantity
        unitPrice
        readyToBeInvoicedAt
        orderContainerId
        bookingId
        bookingStartsAt
      }
    }
  }
`

const InvoiceLines = (props) => {
  const [getServiceProvider, { loading, data }] = useLazyQuery(
    ServiceProviderQuery
  )

  const invoiceLines = data?.serviceProvider?.invoiceLines || []

  return (
    <Layout {...props} title="Honorarer">
      <DatePicker
        loading={loading}
        onSubmit={(dateRange) => {
          const [from, to] = dateRange
          getServiceProvider({
            variables: { from, to },
          })
        }}
      />

      <Invoices loading={loading} invoiceLines={invoiceLines} />
    </Layout>
  )
}

export default InvoiceLines
